module.exports = __webpack_public_path__ + "static/media/Mask.83a782de.png";